module.exports = {
    siteMetadata: {
        title: 'Sunshine Conversations Docs',
        description: 'Sunshine Conversations Docs',
        siteUrl: 'https://docs.smooch.io',
        author: 'Smooch.io',
        subsections: [
            {
                id: 'guide',
                name: 'Home',
                section: 'guide',
                pages: [
                    '/guide/',
                    'API quickstart__https://developer.zendesk.com/documentation/conversations/getting-started/api-quickstart/',
                    'Key concepts__https://developer.zendesk.com/documentation/conversations/getting-started/key-concepts/',
                ],
            },
            {
                id: 'programmable-messaging',
                name: 'Programmable Conversations',
                section: 'guide',
                pages: [
                    'Receiving Messages__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/receiving-messages/',
                    'Sending Messages__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/sending-messages/',
                    'Structured Messages__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/structured-messages/',
                    'Delivery Events__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/delivery-events/',
                    'Channel Transfer__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/channel-transfer/',
                    'Template Messages__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/template-messages/',
                    'WhatsApp Message Templates__https://support.zendesk.com/hc/en-us/articles/5869718332954',
                    'Conversation Extensions__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/conversation-extensions/',
                    'CSAT__https://support.zendesk.com/hc/en-us/articles/4408886173338',
                    'Outbound Messaging__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/outbound-messaging/',
                    'Switchboard__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/switchboard/',
                    '/guide/clearing-conversations/',
                    'Using Metadata__https://support.zendesk.com/hc/en-us/articles/5658339908378',
                    'Conversation Referrals__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/conversation-referrals/',
                ],
            },
            {
                id: 'channels',
                name: 'Channels',
                section: 'guide',
                pages: [
                    '/guide/intro-to-channels/',
                    'Channel capabilities__/guide/channel-capabilities/',
                    '/guide/apple-messages-for-business/',
                    '/guide/facebook-messenger/',
                    '/guide/instagram/',
                    '/guide/line/',
                    '/guide/messagebird-sms/',
                    '/guide/native-android-sdk/',
                    '/guide/native-ios-sdk/',
                    '/guide/telegram/',
                    '/guide/twilio-sms/',
                    '/guide/twitter/',
                    '/guide/viber/',
                    '/guide/web-messenger/',
                    '/guide/wechat/',
                    '/guide/whatsapp/',
                ],
            },
            {
                id: 'users',
                name: 'Users',
                section: 'guide',
                pages: [
                    'Introduction to Users__https://developer.zendesk.com/documentation/conversations/messaging-platform/users/intro-to-users/',
                    'User Lifecycle__https://developer.zendesk.com/documentation/conversations/messaging-platform/users/user-lifecycle/',
                    'Managing User Information__https://support.zendesk.com/hc/en-us/articles/8851239832090',
                    'Authenticating Users__https://developer.zendesk.com/documentation/conversations/messaging-platform/users/authenticating-users/',
                    'Merging Users__https://developer.zendesk.com/documentation/conversations/messaging-platform/users/merging-users/',
                ],
            },
            {
                id: 'built-in-integrations',
                name: 'Built-in Integrations',
                section: 'guide',
                pages: ['/guide/business-systems/', '/guide/office-hours/'],
            },
            {
                id: 'account-provisioning',
                name: 'Account Provisioning',
                section: 'guide',
                pages: [
                    '/guide/intro-to-account-provisioning/',
                    '/guide/creating-and-managing-apps/',
                    '/guide/configuring-messaging-channels/',
                    '/guide/using-service-accounts/',
                ],
            },
            {
                id: 'authentication',
                name: 'API Authentication',
                section: 'guide',
                pages: [
                    'Authentication overview__https://developer.zendesk.com/documentation/conversations/getting-started/api-authentication/',
                    'Basic authentication__https://developer.zendesk.com/documentation/conversations/getting-started/api-authentication/',
                    'JSON Web Tokens (JWTs)__https://developer.zendesk.com/documentation/conversations/getting-started/api-authentication/',
                    'Secure credential handling__https://developer.zendesk.com/documentation/conversations/getting-started/api-authentication/',
                ],
            },
            {
                id: 'sunshine-conversations-connect',
                name: 'Sunshine Conversations Connect',
                section: 'guide',
                pages: [
                    'Introduction to Sunshine Conversations Connect__https://developer.zendesk.com/documentation/conversations/how-to-guides/building-a-marketplace-bot/',
                    'OAuth__https://developer.zendesk.com/documentation/conversations/how-to-guides/building-a-marketplace-bot/',
                ],
            },
            {
                id: 'references',
                name: 'References',
                section: 'guide',
                pages: [
                    'Introduction to the v2 API__https://developer.zendesk.com/documentation/conversations/references/api-versioning/',
                    'API Reference__https://developer.zendesk.com/api-reference/conversations/',
                    'API Changelog__https://developer.zendesk.com/documentation/conversations/references/api-versioning/',
                    'API Libraries__https://developer.zendesk.com/documentation/conversations/references/openapi-specification/',
                    'Versioning__https://developer.zendesk.com/documentation/conversations/references/api-versioning/',
                    'Postman Collection__https://developer.zendesk.com/documentation/conversations/references/openapi-specification/',
                    '/changelog/',
                    'Security__https://support.zendesk.com/hc/en-us/articles/4980543927322',
                    'Data storage__https://support.zendesk.com/hc/en-us/articles/4408883599130',
                    '/guide/regions/',
                    'Shorthand__https://developer.zendesk.com/documentation/conversations/references/shorthand-syntax/',
                    'File Validation__https://support.zendesk.com/hc/en-us/articles/8435939957914',
                    '/faq/',
                    'v1 API Documentation__/guide/v1/',
                ],
            },

            ////////// V1 specific documentation
            {
                id: 'guidev1',
                name: 'Home',
                section: 'guidev1',
                pages: [
                    '/guide/v1/',
                    'Key concepts__https://developer.zendesk.com/documentation/conversations/getting-started/key-concepts/',
                ],
            },
            {
                id: 'programmable-messaging',
                name: 'Programmable Conversations',
                section: 'guidev1',
                pages: [
                    'Receiving Messages__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/receiving-messages/',
                    'Sending Messages__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/sending-messages/',
                    'Structured Messages__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/structured-messages/',
                    'Delivery Events__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/delivery-events/',
                    'Channel Transfer__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/channel-transfer/',
                    'Template Messages__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/template-messages/',
                    'WhatsApp Message Templates__https://support.zendesk.com/hc/en-us/articles/5869718332954',
                    'Conversation Extensions__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/conversation-extensions/',
                    'CSAT__https://support.zendesk.com/hc/en-us/articles/4408886173338',
                    'Outbound Messaging__https://developer.zendesk.com/documentation/conversations/messaging-platform/programmable-conversations/outbound-messaging/',
                    '/guide/v1/clearing-conversations/',
                    'Using Metadata__https://support.zendesk.com/hc/en-us/articles/5658339908378',
                ],
            },
            {
                id: 'channels',
                name: 'Channels',
                section: 'guidev1',
                pages: [
                    '/guide/v1/intro-to-channels/',
                    'Channel capabilities__/guide/v1/channel-capabilities/',
                    '/guide/v1/apple-messages-for-business/',
                    '/guide/v1/facebook-messenger/',
                    '/guide/v1/instagram/',
                    '/guide/v1/line/',
                    '/guide/v1/messagebird-sms/',
                    '/guide/v1/native-android-sdk/',
                    '/guide/v1/native-ios-sdk/',
                    '/guide/v1/telegram/',
                    '/guide/v1/twilio-sms/',
                    '/guide/v1/twitter/',
                    '/guide/v1/viber/',
                    '/guide/v1/web-messenger/',
                    '/guide/v1/wechat/',
                    '/guide/v1/whatsapp/',
                ],
            },
            {
                id: 'users',
                name: 'Users',
                section: 'guidev1',
                pages: [
                    'Introduction to Users__https://developer.zendesk.com/documentation/conversations/messaging-platform/users/intro-to-users/',
                    'User Lifecycle__https://developer.zendesk.com/documentation/conversations/messaging-platform/users/user-lifecycle/',
                    'Managing User Information__https://support.zendesk.com/hc/en-us/articles/8851239832090',
                    'Authenticating Users__https://developer.zendesk.com/documentation/conversations/messaging-platform/users/authenticating-users/',
                    'Merging Users__https://developer.zendesk.com/documentation/conversations/messaging-platform/users/merging-users/',
                ],
            },
            {
                id: 'built-in-integrations',
                name: 'Built-in Integrations',
                section: 'guidev1',
                pages: ['/guide/v1/business-systems/', '/guide/v1/office-hours/'],
            },
            {
                id: 'account-provisioning',
                name: 'Account Provisioning',
                section: 'guidev1',
                pages: [
                    '/guide/v1/intro-to-account-provisioning/',
                    '/guide/v1/creating-and-managing-apps/',
                    '/guide/v1/configuring-messaging-channels/',
                    '/guide/v1/using-service-accounts/',
                ],
            },
            {
                id: 'authentication',
                name: 'API Authentication',
                section: 'guidev1',
                pages: [
                    'Authentication overview__https://developer.zendesk.com/documentation/conversations/getting-started/api-authentication/',
                    'Basic authentication__https://developer.zendesk.com/documentation/conversations/getting-started/api-authentication/',
                    'JSON Web Tokens (JWTs)__https://developer.zendesk.com/documentation/conversations/getting-started/api-authentication/',
                    'Secure credential handling__https://developer.zendesk.com/documentation/conversations/getting-started/api-authentication/',
                ],
            },
            {
                id: 'sunshine-conversations-connect',
                name: 'Sunshine Conversations Connect',
                section: 'guidev1',
                pages: [
                    'Introduction to Sunshine Conversations Connect__https://developer.zendesk.com/documentation/conversations/how-to-guides/building-a-marketplace-bot/',
                    'OAuth__https://developer.zendesk.com/documentation/conversations/how-to-guides/building-a-marketplace-bot/',
                ],
            },
            {
                id: 'references',
                name: 'References',
                section: 'guidev1',
                pages: [
                    'API Reference__https://docs.smooch.io/rest/v1/',
                    'API Libraries__https://developer.zendesk.com/documentation/conversations/references/openapi-specification/',
                    'Versioning__https://developer.zendesk.com/documentation/conversations/references/api-versioning/',
                    'Postman Collection__https://developer.zendesk.com/documentation/conversations/references/openapi-specification/',
                    '/changelog/',
                    'Security__https://support.zendesk.com/hc/en-us/articles/4980543927322',
                    'Data Storage__https://support.zendesk.com/hc/en-us/articles/4408883599130',
                    '/guide/regions/',
                    'Shorthand__https://developer.zendesk.com/documentation/conversations/references/shorthand-syntax/',
                    'File Validation__https://support.zendesk.com/hc/en-us/articles/8435939957914',
                    '/faq/',
                ],
            },
            {
                id: 'guidev2',
                name: 'v2 Documentation',
                section: 'guidev1',
                pages: ['Guide__/guide/'],
            },
            ////////////////////////////////////////////////
            {
                id: 'faq',
                name: 'Frequently Asked Questions',
                section: 'faq',
                pages: ['Welcome__/faq/'],
            },
            {
                id: 'customer-channels',
                name: 'Channels',
                section: 'faq',
                pages: [
                    '/faq/android/',
                    '/faq/ios/',
                    '/faq/web-messenger/',
                    '/faq/facebook-messenger/',
                    '/faq/twilio/',
                    '/faq/other-channels/',
                ],
            },
            {
                id: 'business-systems',
                name: 'Business Systems',
                section: 'faq',
                pages: ['/faq/slack/', '/faq/front/', '/faq/other-systems/'],
            },
            {
                id: 'dashboard',
                name: 'Dashboard',
                section: 'faq',
                pages: ['/faq/dashboard/'],
            },
        ],
    },
    pathPrefix: '/',
    plugins: [
        {
            resolve: 'gatsby-source-filesystem',
            options: {
                path: `${__dirname}/src/pages`,
                name: 'pages',
            },
        },
        {
            resolve: 'gatsby-transformer-remark',
            options: {
                plugins: [
                    {
                        resolve: 'gatsby-remark-autolink-headers',
                        options: { offsetY: '-110' /* Offset by the navbar height */ },
                    },
                    'gatsby-remark-prismjs',
                    'gatsby-remark-copy-linked-files',
                    'gatsby-remark-smartypants',
                    'gatsby-remark-component',
                ],
            },
        },
        {
            resolve: 'gatsby-plugin-manifest',
            options: {
                name: 'Smooch Documentation',
                short_name: 'Smooch-docs',
                start_url: '/guide/',
                theme_color: '#03363D',
                icon: 'src/images/sunco_icon_logo.svg',
            },
        },
        'gatsby-plugin-layout',
        'gatsby-plugin-react-helmet',
        // gatsby-plugin-sitemap temporarily disabled due to bug with Gatsby 5.16+
        // See: https://github.com/gatsbyjs/gatsby/issues/38754
        // Alternative: Generate sitemap manually in CI/CD or use netlify-plugin-sitemap
        // 'gatsby-plugin-sitemap',
        {
            resolve: `gatsby-plugin-less`,
            options: {
                cssLoaderOptions: {
                    camelCase: false,
                },
            },
        },
    ],
};
